export function getUrlVars(useHash) {
	const query = Object.assign(
		window.location.search // normal URL vars
			.slice(1)
			.split('&')
			.map(s => s.split('='))
			.reduce((acc, v) => {
				acc[decodeURIComponent(v[0])] = decodeURIComponent(v[1]);
				return acc;
			}, {}),
		/* eslint-disable no-nested-ternary */
		useHash
			? window.location.hash && window.location.hash.split('?')[1]
				? window.location.hash // get URL vars used by vue router in # history mode
						.split('?')[1]
						.split('&')
						.map(s => s.split('='))
						.reduce((acc, v) => {
							acc[decodeURIComponent(v[0])] = decodeURIComponent(v[1]);
							return acc;
						}, {})
				: {}
			: {}
	);
	delete query[''];
	return Object.keys(query).length > 0 ? query : null;
}
